export const navigationByRole = {
  admin: [
    { path: '/', label: 'Dashboard', icon: 'dashboard', section: 'Overview' },
    { path: '/profile', label: 'My Profile', icon: 'members', section: 'Overview' },

    { path: '/members', label: 'Members', icon: 'members', section: 'Members' },
    { path: '/pending-admissions', label: 'Pending Admissions', icon: 'claims', section: 'Members' },
    { path: '/deceased-members', label: 'Deceased Members', icon: 'deceased', section: 'Members' },

    { path: '/payments', label: 'Payments', icon: 'payments', section: 'Finance & Claims' },
    { path: '/payout-register', label: 'Payout Register', icon: 'beneficiaries', section: 'Finance & Claims' },
    { path: '/claims', label: 'Claims', icon: 'claims', section: 'Finance & Claims' },
    { path: '/crdb-requests', label: 'CRDB Requests', icon: 'payments', section: 'Finance & Claims' },
    { path: '/bank-reconciliation', label: 'Bank Reconciliation', icon: 'payments', section: 'Finance & Claims' },

    { path: '/reports', label: 'Reports', icon: 'reports', section: 'Reports' },
    { path: '/health-insurance', label: 'Health Insurance', icon: 'beneficiaries', section: 'Reports' },
    { path: '/audit-trail', label: 'Audit Trail', icon: 'reports', section: 'Reports' },

    { path: '/notifications', label: 'Notifications', icon: 'notify', section: 'Administration' },
    { path: '/support', label: 'Support', icon: 'notify', section: 'Administration' },
    { path: '/account-setup', label: 'Account Setup', icon: 'users', section: 'Administration' },
    { path: '/staff', label: 'Staff & Approvers', icon: 'users', section: 'Administration' },
    { path: '/error-logs', label: 'Error Logs', icon: 'reports', section: 'Administration' },
    { path: '/fee-config', label: 'Fee Settings', icon: 'settings', section: 'Administration' },
    { path: '/govesb-status', label: 'GovESB Status', icon: 'system', section: 'Administration' },
    { path: '/database-backups', label: 'Database Backups', icon: 'system', section: 'Administration' },
    { path: '/system-settings', label: 'System Settings', icon: 'system', section: 'Administration' },
  ],
  finance: [
    { path: '/', label: 'Dashboard', icon: 'dashboard' },
    { path: '/profile', label: 'My Profile', icon: 'members' },
    { path: '/payments', label: 'Payments', icon: 'payments' },
    { path: '/claims', label: 'Claims', icon: 'claims' },
    { path: '/reports', label: 'Reports', icon: 'reports' },
  ],
  board: [
    { path: '/', label: 'Dashboard', icon: 'dashboard' },
    { path: '/profile', label: 'My Profile', icon: 'members' },
    { path: '/claims', label: 'Claims', icon: 'claims' },
  ],
  member: [
    { path: '/', label: 'Dashboard', icon: 'dashboard' },
    { path: '/profile', label: 'My Profile', icon: 'members' },
    { path: '/beneficiaries', label: 'Beneficiaries', icon: 'beneficiaries', section: 'Beneficiary' },
    { path: '/payments', label: 'Payments', icon: 'payments', section: 'Finance' },
    { path: '/receipts', label: 'Receipts', icon: 'receipt', section: 'Finance' },
    { path: '/health-insurance-survey', label: 'Health Insurance', icon: 'beneficiaries', section: 'Health Insurance' },
    { path: '/support', label: 'Support', icon: 'notify', section: 'Help' },
  ],
};

// Maps each admin nav path to the permission group(s) (see
// PermissionsController::CATALOG) that should also unlock it for a user
// whose base role wouldn't normally show it — lets admin grant a single
// capability (e.g. "claims") to a finance/board/member user without
// promoting them to full admin.
const PATH_PERMISSIONS = {
  '/members': ['members', 'member_invite', 'member_status'],
  '/pending-admissions': ['pending_admissions'],
  '/deceased-members': ['members'],
  '/payout-register': ['claims'],
  '/payments': ['payments', 'bank_reconciliation'],
  '/claims': ['claims'],
  '/reports': ['reports'],
  '/health-insurance': ['health_insurance', 'reports'],
  '/staff': ['staff'],
  '/audit-trail': ['audit_trail'],
  '/crdb-requests': ['crdb_requests'],
  '/bank-reconciliation': ['bank_reconciliation'],
  '/error-logs': ['error_logs'],
  '/notifications': ['notifications'],
  '/support': ['support'],
  '/account-setup': ['account_setup'],
  '/fee-config': ['fee_config', 'payment_methods'],
  '/govesb-status': ['system_settings'],
  '/system-settings': ['system_settings', 'zones', 'vpn_status'],
  '/database-backups': ['system_settings'],
};

export function getNavigationForRole(role, permissions = []) {
  const base = navigationByRole[role] || navigationByRole.member;
  if (!permissions || permissions.length === 0) {
    return base;
  }

  const extra = navigationByRole.admin.filter((item) => {
    if (base.some((b) => b.path === item.path)) return false;
    const required = PATH_PERMISSIONS[item.path];
    return required && required.some((key) => permissions.includes(key));
  });

  return extra.length > 0 ? [...base, ...extra] : base;
}
